import { AdminUserActivityResponse } from "../contracts/AdminUserActivityResponse";
import { ActivationStep, AdminUserActivity } from "../models/AdminUserActivity";

const toDate = (value: string | null | undefined): Date | null => (value ? new Date(value) : null);

const toFunnel = (response: AdminUserActivityResponse): ActivationStep[] => [
  { kind: "member", count: response.memberCount, firstAt: toDate(response.firstMemberAt) },
  { kind: "session", count: response.sessionCount, firstAt: toDate(response.firstSessionAt) },
  { kind: "contract", count: response.contractCount, firstAt: toDate(response.firstContractAt) },
  { kind: "visit", count: response.visitCount, firstAt: toDate(response.firstVisitAt) },
  { kind: "payment", count: response.paymentCount, firstAt: toDate(response.firstPaymentAt) },
];

export const mapResponseToAdminUserActivity = (
  response: AdminUserActivityResponse
): AdminUserActivity => ({
  instructorId: response.instructorId,
  organizationName: response.organizationName,
  signupDate: new Date(response.signupDate),
  lastActiveAt: toDate(response.lastActiveAt),
  funnel: toFunnel(response),
  timeline: (response.timeline ?? [])
    .map((entry) => ({ kind: entry.kind, createdAt: new Date(entry.createdAt) }))
    .sort((a, b) => b.createdAt.getTime() - a.createdAt.getTime()),
});
